export default __webpack_public_path__ + "static/media/recorte_21.3bd2bd95.JPG";